module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/stmtfw.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fstmtfw.png
// module id = RTtq
// module chunks = 93